// Ui manager libarary.
// Responsible for managing, initing and deiniting UI libraries (such as styled dropdowns, carousels, buttons etc).

app.registerLib('ui', function(app) {

	return {

        // Where all the registered UI plugin interfaces are stored
		uiPlugins: {},

        // The mechanism by which UI plugin interfaces are registerd
		registerUi: function(uiKey, uiConstructorFunc) {
			var scope = this;
			scope.uiPlugins[uiKey] = uiConstructorFunc(app);
		},

        // Notifies each ui plugin that a resource has loaded, and lets
        // each module individually decide how to react
        onLoaded: function (data) {
            var scope = this;
			Object.keys(this.uiPlugins).forEach(function(uiPluginKey) {
				var uiPlugin = scope.uiPlugins[uiPluginKey];
				if (typeof uiPlugin.onLoaded == 'function') {
				    uiPlugin.onLoaded(data);
				}
			});
        },

	    // Cycles through all registered UI plugin interfaces, and calls the 'init' method on them if it exsits,
	    // which it will most of the time. The argument $scope may be optionally provided, but when provided,
	    // must be a jQuery DOM collection / node. When present, the UI plugin is only applied to elements found within
        // that node / collection.
		initAll: function ($scope) {
			var scope = this;
			Object.keys(this.uiPlugins).forEach(function(uiPluginKey) {
				var uiPlugin = scope.uiPlugins[uiPluginKey];
				if (typeof uiPlugin.init == 'function') {
				    uiPlugin.init($scope);
				}
			});
		},

	    // Cycles through all registered UI plugin interfaces, and calls the 'deinit' method on them if it exsits,
	    // which it will most of the time. Deinit should destroy all listeners and dynamically created HTML
        // associated with that plugin. As with init, a $scope may also be provided.
		deinitAll: function($scope) {
            var scope = this;
			Object.keys(this.uiPlugins).forEach(function(uiPluginKey) {
                var uiPlugin = scope.uiPlugins[uiPluginKey];
				if (typeof uiPlugin.deinit == 'function') {
					uiPlugin.deinit($scope);
				}
			});
        },

	};
});
